import type { PhotosGroupData, ExitsOrderData } from "@/types/types.d";
import { create } from "zustand";
import { EXITS_INITAL_STATE } from "@/constants/constants";

const initial_store = EXITS_INITAL_STATE as ExitsOrderData;

interface CaputureStandState {
  exitsData: ExitsOrderData;
  exitsGroupData: PhotosGroupData[];
  updateExtisData: (data: ExitsOrderData) => void;
  updateExitsGroupData: (data: PhotosGroupData) => void;
  addExitsGroupData: (data: PhotosGroupData) => void;
  clearExitsGroupData: () => void;
}

const useExitsDataStore = create<CaputureStandState>((set, get) => ({
  exitsData: initial_store,
  exitsGroupData: [],
  updateExtisData: (orderData: ExitsOrderData) => set({ exitsData: orderData }),
  updateExitsGroupData: (groupData: PhotosGroupData) => {
    const newGroups = get().exitsGroupData;
    const newGroupsList = newGroups.map((group) => {
      if (group.id !== groupData.id) return group;
      return groupData;
    });

    set({
      exitsGroupData: newGroupsList.filter(
        (groupElement) => groupElement.photos.length > 0,
      ),
    });
  },

  addExitsGroupData: (gruopData: PhotosGroupData) => {
    const newGroupData = get().exitsGroupData;
    set({ exitsGroupData: [...newGroupData, gruopData] });
  },
  clearExitsGroupData: () => {
    set({ exitsData: initial_store });
    set({ exitsGroupData: [] });
  },
}));

export default useExitsDataStore;
